<template>
  <div></div>
</template>
<script>
export default {
  created() {
    this.$store.commit("settoken", null);
    this.$store.commit("setuserInfo", null);
    sessionStorage.clear()
    this.$router.push("/login");
  },
}
</script>